import { mapState, mapActions } from 'vuex'
import Vue from 'vue'

const navigation = Vue.mixin({
  computed: {
    ...mapState('booking/request/vetting', { vettingCount: 'count' }),
    ...mapState('message', ['unread_count']),
    ...mapState('notifications', ['notification_unread_count']),

    userOptions () {
      const options = [
        { label: this.$t('menu.clients'), view: 'clients.index' },
        { label: this.$options.filters.sentenceCase(this.$starLabelPlural), view: 'talent.index' }
      ]
      if (this.$managerModuleEnabled) {
        options.push({
          label: this.$t('menu.managers'),
          view: 'managers.index'
        })
      }
      if (this.$userIsGlobalAdmin) {
        options.push({ label: 'Admins', view: 'system.admin-management' })
      }
      if (!this.$vlastMode && this.$userIsGlobalAdmin) {
        options.push({ label: 'Interns', view: 'system.intern-management' })
      }
      return options
    },

    settingsOptions () {
      let options = []

      if (this.$userIsSuperAdmin && this.$vlastMode) {
        options = [
          { label: this.$t('menu.system'), view: 'system.settings' },
          { label: 'Opportunity Types', view: 'system.opportunities' },
          { label: 'Departments', view: 'system.departments' },
          { label: 'Regions', view: 'system.regions' }
        ]
        if (this.$categoryModuleEnabled) {
          options.push({ label: 'Categories', view: 'system.categories' })
        }
        if (this.$talentContractsModuleEnabled) {
          options.push({ label: 'Contracts', view: 'system.contracts' })
        }
      }

      return options
    },

    importOptions () {
      let options = []

      if (this.$userIsSuperAdmin) {
        options = [
          { label: this.$t('menu.user_import'), view: 'importer' },
          { label: this.$t('menu.booking_import'), view: 'booking-importer' }
        ]
      } else {
        options = [
          { label: this.$t('menu.user_import'), view: 'importer' }
        ]
        if (this.$categoryModuleEnabled) {
          options.push({ label: 'Categories', view: 'system.categories' })
        }
      }

      return options
    },

    tagOptions () {
      if (this.$vlastMode) {
        return {
          items: [
            {label: 'Tags', view: 'system.tags'}
          ]
        }
      }
      return {
        heading: 'Tags',
        items: [
          {label: 'Manage', view: 'system.tags'},
          {label: 'Tree', view: 'system.tags.tree'}
        ]
      }
    },

    requestItems () {
      const items = [
        { label: 'Pending', view: 'vetting.index', counter: this.vettingCount },
        {
          label: this.$billboardModuleEnabled ? 'Private' : 'Active',
          view: 'requests.index'
        }
      ]
      if (this.$billboardModuleEnabled) {
        items.push({ label: 'Public', view: 'billboard.index' })
      }
      return items
    },

    navigation () {
      return {
        admin: [
          {
            cta: true,
            items: [
              { label: this.$t('menu.request_a_star'), icon: 'fa-plus', view: 'requests.create' }
            ]
          },
          ...[
            this.$campaigns
              ? {
                items: [
                  {
                    label: 'Campaigns',
                    view: 'campaigns.index'
                  }
                ]
              }
              : {
                items: []
              }
          ],
          {
            heading: this.$t('Requests'),
            items: this.requestItems
          },
          {
            items: [{ label: this.$t('menu.bookings'), view: 'bookings.index' }]
          },
          ...[
            this.$paymentsModuleEnabled
              ? {
                items: [{ label: 'Payments', view: 'payments.index' }]
              }
              : {
                items: []
              }
          ],
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            heading: 'Notifications',
            items: [
              { label: 'Send', view: 'system.notifications.create' },
              { label: 'Sent Notifications', view: 'system.notifications' }
            ]
          },
          {
            heading: 'Dashboards',
            items: [
              { label: 'Calendar', view: 'calendar.index' },
              { label: 'Analytics', view: 'bidashboards.index' }
            ]
          },
          {
            items: [{ label: 'Reports', view: 'system.reports' }]
          },
          {...this.tagOptions},
          {
            heading: 'Users',
            items: this.userOptions
          },
          {
            heading: 'Imports',
            items: this.importOptions
          },
          {
            heading: 'Settings',
            items: this.settingsOptions
          }
        ],
        'reporting-admin': [
          {
            items: [{ label: 'Analytics', view: 'bidashboards.index' }]
          },
          {
            items: [{ label: 'Reports', view: 'system.reports' }]
          }
        ],
        'restricted-admin': [
          {
            cta: true,
            items: [
              { label: this.$t('menu.request_a_star'), view: 'requests.create' }
            ]
          },
          {
            heading: this.$t('Requests'),
            items: this.requestItems
          },
          {
            items: [{ label: this.$t('menu.bookings'), view: 'bookings.index' }]
          },
          ...[
            this.$paymentsModuleEnabled
              ? {
                items: [{ label: 'Payments', view: 'payments.index' }]
              }
              : {
                items: []
              }
          ],
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            heading: 'Notifications',
            items: [
              { label: 'Send', view: 'system.notifications.create' },
              { label: 'Sent Notifications', view: 'system.notifications' }
            ]
          },
          {
            heading: 'Dashboards',
            items: [
              { label: 'Calendar', view: 'calendar.index' },
              { label: 'Analytics', view: 'bidashboards.index' }
            ]
          },
          {
            items: [{ label: 'Reports', view: 'system.reports' }]
          },
          {
            items: [{ label: 'Tags', view: 'system.tags' }]
          },
          {
            heading: 'Users',
            items: this.userOptions
          },
          {
            items: [
              {label: 'Import Users', view: 'importer'}
            ]
          }
        ],
        'regional-admin': [
          {
            cta: true,
            items: [
              { label: this.$t('menu.request_a_star'), view: 'requests.create' }
            ]
          },
          {
            heading: this.$t('Requests'),
            items: this.requestItems
          },
          {
            items: [{ label: this.$t('menu.bookings'), view: 'bookings.index' }]
          },
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            heading: 'Notifications',
            items: [
              { label: 'Send', view: 'system.notifications.create' },
              { label: 'Sent Notifications', view: 'system.notifications' }
            ]
          },
          {
            heading: 'Dashboards',
            items: [
              { label: 'Calendar', view: 'calendar.index' },
              { label: 'Analytics', view: 'bidashboards.index' }
            ]
          },
          {
            items: [{ label: 'Reports', view: 'system.reports' }]
          },
          {
            items: [{ label: 'Tags', view: 'system.tags' }]
          },
          {
            heading: 'Users',
            items: this.userOptions
          },
          {
            items: [
              {label: 'Import Users', view: 'importer'}
            ]
          }
        ],
        'super-regional-admin': [
          {
            cta: true,
            items: [
              { label: this.$t('menu.request_a_star'), view: 'requests.create' }
            ]
          },
          {
            items: [
              {label: 'Import Users', view: 'importer'}
            ]
          },
          {
            heading: this.$t('Requests'),
            items: this.requestItems
          },
          {
            items: [{ label: this.$t('menu.bookings'), view: 'bookings.index' }]
          },
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            heading: 'Notifications',
            items: [
              { label: 'Send', view: 'system.notifications.create' },
              { label: 'Sent Notifications', view: 'system.notifications' }
            ]
          },
          {
            heading: 'Dashboards',
            items: [
              { label: 'Calendar', view: 'calendar.index' },
              { label: 'Analytics', view: 'bidashboards.index' }
            ]
          },
          {
            items: [{ label: 'Reports', view: 'system.reports' }]
          },
          {
            items: [{ label: 'Tags', view: 'system.tags' }]
          },
          {
            heading: 'Users',
            items: this.userOptions
          },
          {
            items: [
              {label: 'Import Users', view: 'importer'}
            ]
          }
        ],
        sales: [
          {
            cta: true,
            items: [
              { label: this.$t('menu.request_a_star'), view: 'requests.create' }
            ]
          },
          {
            heading: this.$t('Requests'),
            items: this.requestItems
          },
          {
            items: [{ label: this.$t('menu.bookings'), view: 'bookings.index' }]
          },
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            heading: 'Users',
            items: [
              { label: this.$t('menu.clients'), view: 'clients.index' },
              { label: this.$options.filters.sentenceCase(this.$starLabelPlural), view: 'talent.index' },
              { label: this.$t('menu.managers'), view: 'managers.index' }
            ]
          }
        ],
        client: [
          {
            cta: true,
            items: [
              { label: this.$t('menu.request_a_star'), view: 'requests.create' }
            ]
          },
          {
            items: [{ label: 'My ' + this.$t('Requests'), view: 'requests.index' }]
          },
          {
            items: [{ label: 'My Bookings', view: 'bookings.index' }]
          },
          {
            items: [{ label: 'Calendar View', view: 'calendar.index' }]
          },
          ...[
            this.$vlastMode && this.$showClientBIBudgetPerStateEnabled ? {
              items: [
                { label: 'Analytics', view: 'bidashboards.index' }
              ]
            } : { items: [] }
          ],
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            items: [
              {
                label: 'Notifications',
                view: 'notifications.index',
                icon: 'bell-o',
                counter: this.notification_unread_count
              }
            ]
          }
        ],
        talent: [
          {
            cta: true,
            items: !this.$billboardModuleEnabled
              ? []
              : [{ label: 'Discover', view: 'billboard.index' }]
          },
          {
            items: [{ label: this.$t('Requests'), view: 'requests.index' }]
          },
          {
            heading: 'My Bookings',
            items: [
              { label: 'Bookings', view: 'bookings.index' },
              { label: 'Calendar View', view: 'calendar.index' }
            ]
          },
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            items: [
              {
                label: 'Notifications',
                view: 'notifications.index',
                icon: 'bell-o',
                counter: this.notification_unread_count
              }
            ]
          },
          {
            items: !this.$billboardModuleEnabled
              ? []
              : [{ label: 'Discover', view: 'billboard.index' }]
          }
        ],
        manager: [
          {
            cta: true,
            items: !this.$billboardModuleEnabled
              ? []
              : [{ label: 'Discover', view: 'billboard.index' }]
          },
          {
            heading: 'My Bookings',
            items: [
              { label: this.$t('Requests'), view: 'requests.index' },
              { label: 'Bookings', view: 'bookings.index' },
              { label: 'Calendar View', view: 'calendar.index' }
            ]
          },
          ...[
            this.$chatsModuleEnabled
              ? {
                items: [
                  {
                    label: 'Chats',
                    view: 'threads.index',
                    icon: 'comments',
                    counter: this.unread_count
                  }
                ]
              } : {
                items: []
              }
          ],
          {
            items: [
              {
                label: 'Notifications',
                view: 'notifications.index',
                icon: 'bell-o',
                counter: this.notification_unread_count
              }
            ]
          },
          {
            items: !this.$billboardModuleEnabled
              ? []
              : [{ label: 'Discover', view: 'billboard.index' }]
          },
          {
            items: [{ label: 'My ' + this.$options.filters.sentenceCase(this.$starLabelPlural), view: 'talent.index' }]
          },
          {
            items: [{ label: 'Import Users', view: 'importer' }]
          }
        ],
        intern: [
          {
            items: [{ label: this.$t('Requests'), view: 'requests.index' }]
          },
          {
            items: [{ label: 'Bookings', view: 'bookings.index' }]
          },
          {
            items: [{ label: this.$options.filters.sentenceCase(this.$starLabelPlural), view: 'talent.index' }]
          },
          {
            items: [{ label: 'Tags', view: 'system.tags' }]
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions('notifications', ['getUnreadCount']),
    ...mapActions('message', { getUnreadCountMessaging: 'getUnreadCount' })
  }
})

export default {
  navigation
}
